<template>
  <div id="contenedor-funcionarios-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'FuncionariosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
